import {Typography} from '@mui/material'
import {AppBar} from '../components/AppBar'

export const ErrorRoute = () => {
  return (
    <>
      <AppBar />
      <Typography sx={{mt: 3}} align='center' variant='h3'>
        Page Not Found
      </Typography>
    </>
  )
}
